<template>
  <div
    class="aspect-square bg-white rounded-full flex items-center justify-center shadow-lg"
  >
    <SpriteSymbol name="check" class="size-[55%] text-green-600" />
  </div>
</template>
